import TextButton from 'LuxKit/Button/TextButton'
import SolidPlusIcon from 'LuxKit/Icons/solid/SolidPlusIcon'
import TextLink from 'LuxKit/TextLink'
import Caption from 'LuxKit/Typography/Caption'
import { MAX_ROOM_LIMIT } from 'constants/offer'
import { pluralizeToString } from 'lib/string/pluralize'
import React from 'react'
import { connect } from 'react-redux'
import { getSupportContact } from 'selectors/supportContactSelector'

interface Props {
  className?: string
  contactNumber?: App.GeoContact
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  roomsCount: number
  saleUnit?: string
  maxRooms?: number
  noServiceContact?: boolean
}

function AddRoomButton(props: Props) {
  const {
    className,
    contactNumber,
    onClick,
    roomsCount,
    saleUnit,
    maxRooms = MAX_ROOM_LIMIT,
    noServiceContact,
  } = props
  const unit = saleUnit || 'room'
  const pluralizeSaleUnit = pluralizeToString(unit, maxRooms)

  return (
    <div className={className} data-testid="add-room-button">
      {roomsCount < maxRooms && <TextButton
        kind="tertiary"
        size="medium"
        startIcon={<SolidPlusIcon />}
        horizontalOutdent="start"
        onClick={onClick}
      >
        Add another {unit}
      </TextButton>}
      {(roomsCount >= maxRooms && !noServiceContact && contactNumber) &&
        <Caption variant="medium" weight="bold">
          <>
            For bookings of more than {pluralizeSaleUnit} please contact our customer service team on{' '}
            <TextLink href={`tel:${contactNumber.number}`} rel="nofollow">
              {contactNumber.humanReadable}
            </TextLink>.
          </>
        </Caption>}
    </div>
  )
}

function mapStateToProps(state: App.State) {
  return {
    contactNumber: getSupportContact(state).defaultContact,
  }
}

export default connect(mapStateToProps)(AddRoomButton)
